import { createAsyncThunk } from "@reduxjs/toolkit";
import apiCalls from "../../../PowerShadesAPIFunctions";
import { AxiosError } from "axios";
import { extraEntityReducersFunction, loadStatus } from "../entitiesType";
import { CouponReasonTypes } from "../../../powershadesApiTypes";

const loadCouponReasonTypes = createAsyncThunk<CouponReasonTypes[], void, {
    rejectValue: boolean;
}>(
    'entities/GetCouponReasonTypes',
    async (_inputs, { rejectWithValue }) => {
        try {
            const resp = await apiCalls.getCouponReasons();
            return resp.data.reason_types as unknown as CouponReasonTypes[];
        } catch (err: any) {
            const error: AxiosError = err;
            console.error(error);
            return rejectWithValue(false);
        }
    }
);

export const couponReasonTypesBuilder: extraEntityReducersFunction = (builder) => {
    builder.addCase(loadCouponReasonTypes.fulfilled, (state, action) => {
        state.couponReasonTypes.list = action.payload;
        state.couponReasonTypes.loadStatus = loadStatus.fullyLoaded;
    });

    builder.addCase(loadCouponReasonTypes.pending, (state) => {
        state.couponReasonTypes.loadStatus = loadStatus.loading;
    });
};

export { loadCouponReasonTypes };
